"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Wrap a react component with a deprecated message.
 * @param {Object} config - Information regarding the component being deprecated.
 * @param {string} config.obsolete - The name of the obsolete component.
 * @param {string} config.new - The new component which should be used.
 */
const withDeprecated = config => WrappedComponent => props => {
    const message = `!!! [DEPRECATION] - 'atomic ${config.obsolete}' is deprecated. Please use '${config.new}' instead !!!`;
    console.warn(message);
    return jsx_runtime_1.jsx(WrappedComponent, Object.assign({}, props), void 0);
};
exports.default = withDeprecated;
//# sourceMappingURL=withDeprecated.js.map